module.exports = __webpack_public_path__ + "img/02.142ae1be.jpg";